"use client";

import { motion } from "framer-motion";
import Link from "next/link";
import { useLocalePath } from "@/i18n/LangContext";

interface WorkContactCtaProps {
  text: string;
  buttonText: string;
}

export function WorkContactCta({ text, buttonText }: WorkContactCtaProps) {
  const lp = useLocalePath();
  return (
    <motion.div
      className="mt-16 text-center"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.8, duration: 0.6 }}
    >
      <p className="mb-6 text-lg">{text}</p>
      <Link href={lp("/contact")}>
        <motion.button
          className="px-8 py-4 rounded-lg bg-[#1E0B32] text-[#ff88ff] border border-[#ff88ff]/30 font-medium"
          whileHover={{
            scale: 1.05,
            backgroundColor: 'rgba(40, 20, 60, 1)'
          }}
          whileTap={{ scale: 0.97 }}
        >
          {buttonText}
        </motion.button>
      </Link>
    </motion.div>
  );
}